import React, {Component} from 'react';
import $ from 'jquery'
import {Link} from 'react-router-dom';
import * as Common from '../CommonControlls/CommonJs';
import {connect} from 'react-redux'
import AppLogo_Background from '../../images/AppLogo_Background.png'
import SignUp_Background from '../../images/SignUp_Background.png'
import DropDown from '../CommonControlls/DropdownRendrer'


const mapStateToProps = (store) => {
    return store
}

const mapDispatchToProps = (dispatch) => {
    return {
        ShowAlert: (Settings) => {
            dispatch({type: "UpdateAlert", payload: Settings})
        },
        ShowLoader: (Isloading) => {
            dispatch({type: "UpdateLoader", payload: Isloading})
        },
    }
}

class Signup extends Component {
    constructor(props) {
        super(props);
        this.state = {

            RolesLoader: false,
            Roleslist: [],
            RoleId: 0,

            HCFLoader: false,
            BHUList: [],
            RHCList: [],
            BHUId: 0,
            RHCId: 0,

            XpertSiteLoader: false,
            XpertSitelist: [],
            XpertSiteId: 0,

            DistrictLoader: false,
            Districtlist: [],
            DistrictId: 0,

            verificationCode: null,
            isExpired: true,

            ProvinceLoader: false,
            Provincelist: [],
            ProvinceId: 0,

            FilteredDistrictlist: [],
            AddressDistrictId: 0,

            TehsilLoader: false,
            Tehsillist: [],
            FilteredTehsillist: [],
            TehsilId: 0,

            Banklist: [],
            BankId: 0,
            BankLoader: false

        };
    }

    HandleAutoSuggestValChange = (fieldId, value) => {
        this.setState({[fieldId]: value}, () => {
            if (fieldId == "ProvinceId") {
                var TempArr = this.state.Districtlist
                var filteredArr = TempArr.filter(function (obj) {
                    return obj.provinceId == value;
                });
                this.setState({
                    FilteredDistrictlist: filteredArr,
                })
            }
            if (fieldId == "AddressDistrictId") {
                var TempArr = this.state.Tehsillist
                var filteredArr = TempArr.filter(function (obj) {
                    return obj.districtId == value;
                });
                this.setState({
                    FilteredTehsillist: filteredArr,
                })
            }
        })
    }

    render() {

        return (

            <div class="login_Container row">

                <div class="side_Image">
                    <img src={AppLogo_Background} style={{height: "65px"}}/>
                    <p>Register to Riders For Health</p>
                    <img src={SignUp_Background} style={{maxHeight: "410.5px", maxWidth: "594.8px"}}/>
                </div>

                <form id="Form_1stStep" class="login_form" onSubmit={this.ValidateSignUp} novalidate
                      style={{paddingTop: "2vh"}}>

                    <div class="Form_PageTitle">Register</div>

                    <div class="loginform_Content" style={{marginTop: "0px"}}>
                        <p style={{marginBottom: "10px", fontSize: "15px"}}>It only takes a few seconds to create your
                            account.</p>
                        <p>Already have an account? <Link to="/Login" class="basicLink_Tag"> Sign In</Link></p>
                    </div>

                    <div class="loginform_form row d-flex justify-content-center" style={{paddingTop: "0px"}}>

                        <div class="formInput_Container col-md-12 col-lg-12 col-12" style={{maxWidth: "420px"}}>
                            <label for=""><span style={{color: "red"}}>* </span>Name</label>
                            <input autocomplete="off" type="text" class="form-control" id="SignUp_Name"
                                   placeholder="Enter your full name" autoFocus required/>
                        </div>

                        <div class="formInput_Container col-md-12 col-lg-12 col-12" style={{maxWidth: "420px"}}>
                            <label for=""><span style={{color: "red"}}>* </span>Phone</label>
                            <input autocomplete="off" pattern="[0][0-9]{10}" type="text" class="form-control"
                                   id="SignUp_Contact" placeholder="Enter your phone - 03123456789" required/>
                        </div>

                        <div class="formInput_Container col-md-12 col-lg-12 col-12" style={{maxWidth: "420px"}}>
                            <label for="">Email</label>
                            <input autocomplete="off" type="email" class="form-control" id="SignUp_Email"
                                   placeholder="Enter your email"/>
                        </div>

                        <div class="formInput_Container col-md-12 col-lg-12 col-12" style={{maxWidth: "420px"}}>
                            <label for=""><span style={{color: "red"}}>* </span>Password</label>
                            <input autocomplete="off" type="password" class="form-control" id="SignUp_Password"
                                   placeholder="Enter your password" required/>
                            <i id="viewpasswordlink" onClick={((e) => this.updatepasswordviewfun(1))}
                               class="fa fa-eye viewpasswordicon" aria-hidden="true"></i>
                            <i id="hidepasswordlink" onClick={((e) => this.updatepasswordviewfun(2))}
                               class="fa fa-eye-slash viewpasswordicon" style={{display: "none"}}
                               aria-hidden="true"></i>
                        </div>

                        <div class="formInput_Container col-md-12 col-lg-12 col-12" style={{maxWidth: "420px"}}>
                            <label for=""><span style={{color: "red"}}>* </span> Province</label>
                            <DropDown
                                multi={false}
                                dropdownRenderer={false}
                                create={false}
                                onChange={this.HandleAutoSuggestValChange}
                                Type="ProvinceId"
                                options={this.state.Provincelist}
                                val={this.state.ProvinceId}
                                addPlaceholder=""
                                disabled={false}
                                loading={this.state.ProvinceLoader}
                                searchBy="name"
                                labelField="name"
                                valueField="id"
                                contentRenderer={false}
                                placeholder="Select"
                            />
                        </div>

                        <div class="formInput_Container col-md-12 col-lg-12 col-12" style={{maxWidth: "420px"}}>
                            <label for=""><span style={{color: "red"}}>* </span> District</label>
                            <DropDown
                                multi={false}
                                dropdownRenderer={false}
                                create={false}
                                onChange={this.HandleAutoSuggestValChange}
                                Type="AddressDistrictId"
                                options={this.state.FilteredDistrictlist}
                                val={this.state.AddressDistrictId}
                                addPlaceholder=""
                                disabled={false}
                                loading={this.state.DistrictLoader}
                                searchBy="name"
                                labelField="name"
                                valueField="id"
                                contentRenderer={false}
                                placeholder="Select"
                            />
                        </div>

                        <div class="formInput_Container col-md-12 col-lg-12 col-12" style={{maxWidth: "420px"}}>
                            <label for=""><span style={{color: "red"}}>* </span> Tehsil</label>
                            <DropDown
                                multi={false}
                                dropdownRenderer={false}
                                create={false}
                                onChange={this.HandleAutoSuggestValChange}
                                Type="TehsilId"
                                options={this.state.FilteredTehsillist}
                                val={this.state.TehsilId}
                                addPlaceholder=""
                                disabled={false}
                                loading={this.state.TehsilLoader}
                                searchBy="name"
                                labelField="name"
                                valueField="id"
                                contentRenderer={false}
                                placeholder="Select"
                            />
                        </div>

                        <div class="formInput_Container col-md-12 col-lg-12 col-12" style={{maxWidth: "420px"}}>
                            <label for=""><span style={{color: "red"}}>* </span>Role</label>
                            <DropDown
                                multi={false}
                                dropdownRenderer={false}
                                create={false}
                                onChange={this.HandleAutoSuggestValChange}
                                Type="RoleId"
                                options={this.state.Roleslist}
                                val={this.state.RoleId}
                                addPlaceholder=""
                                disabled={false}
                                loading={this.state.RolesLoader}
                                searchBy="roleName"
                                labelField="roleName"
                                valueField="id"
                                contentRenderer={false}
                                placeholder="Select"
                            />
                        </div>

                        <div class="formInput_Container col-md-12 col-lg-12 col-12" style={{maxWidth: "420px"}}
                             hidden={this.state.RoleId == 6 ? false : true}>
                            <label for=""><span style={{color: "red"}}>* </span>BHU</label>
                            <DropDown
                                multi={false}
                                dropdownRenderer={false}
                                create={false}
                                onChange={this.HandleAutoSuggestValChange}
                                Type="BHUId"
                                options={this.state.BHUList}
                                val={this.state.BHUId}
                                addPlaceholder=""
                                disabled={false}
                                loading={this.state.HCFLoader}
                                searchBy="name"
                                labelField="name"
                                valueField="id"
                                contentRenderer={false}
                                placeholder="Select"
                            />
                        </div>

                        <div class="formInput_Container col-md-12 col-lg-12 col-12" style={{maxWidth: "420px"}}
                             hidden={this.state.RoleId == 7 ? false : true}>
                            <label for=""><span style={{color: "red"}}>* </span>RHC</label>
                            <DropDown
                                multi={false}
                                dropdownRenderer={false}
                                create={false}
                                onChange={this.HandleAutoSuggestValChange}
                                Type="RHCId"
                                options={this.state.RHCList}
                                val={this.state.RHCId}
                                addPlaceholder=""
                                disabled={false}
                                loading={this.state.HCFLoader}
                                searchBy="name"
                                labelField="name"
                                valueField="id"
                                contentRenderer={false}
                                placeholder="Select"
                            />
                        </div>

                        <div class="formInput_Container col-md-12 col-lg-12 col-12" style={{maxWidth: "420px"}}
                             hidden={this.state.RoleId == 3 ? false : true}>
                            <label for=""><span style={{color: "red"}}>* </span> Xpert Site</label>
                            <DropDown
                                multi={false}
                                dropdownRenderer={false}
                                create={false}
                                onChange={this.HandleAutoSuggestValChange}
                                Type="XpertSiteId"
                                options={this.state.XpertSitelist}
                                val={this.state.XpertSiteId}
                                addPlaceholder=""
                                disabled={false}
                                loading={this.state.XpertSiteLoader}
                                searchBy="name"
                                labelField="name"
                                valueField="id"
                                contentRenderer={false}
                                placeholder="Select"
                            />
                        </div>

                        {/* <div class="formInput_Container col-md-12 col-lg-12 col-12" style={{maxWidth:"420px"}} hidden={this.state.RoleId==5?false:true}>
            <label for=""><span style={{color:"red"}}>* </span> District To Supervise</label>
                <DropDown
                    multi={false}
                    dropdownRenderer = {false}
                    create = {false}
                    onChange={this.HandleAutoSuggestValChange}
                    Type="DistrictId"
                    options={this.state.Districtlist}
                    val={this.state.DistrictId}
                    addPlaceholder=""
                    disabled={false}
                    loading={this.state.DistrictLoader}
                    searchBy="name"
                    labelField="name"
                    valueField="id"
                    contentRenderer={false}
                    placeholder="Select"
                />
        </div> */}

                        <div class="formInput_Container col-md-12 col-lg-12 col-12" style={{maxWidth: "420px"}}
                             hidden={this.state.RoleId == 4 ? false : true}>
                            <label for=""><span style={{color: "red"}}>* </span>Vehicle Number</label>
                            <input autocomplete="off" type="text" class="form-control" id="SignUp_VehicleNumber"
                                   placeholder="Enter your vehicle number"
                                   required={this.state.RoleId == 4 ? true : false}/>
                        </div>

                        <div class="formInput_Container col-md-12 col-lg-12 col-12" style={{maxWidth: "420px"}}
                             hidden={this.state.RoleId == 4 ? false : true}>
                            <label for=""><span style={{color: "red"}}>* </span>Vehicle Model</label>
                            <input autocomplete="off" type="text" class="form-control" id="SignUp_VehicleModel"
                                   placeholder="Enter your vehicle model"
                                   required={this.state.RoleId == 4 ? true : false}/>
                        </div>

                        <div class="formInput_Container col-md-12 col-lg-12 col-12" style={{maxWidth: "420px"}}
                             hidden={this.state.RoleId == 4 ? false : true}>
                            <label for="">Bank</label>
                            <DropDown
                                multi={false}
                                dropdownRenderer={false}
                                create={false}
                                onChange={this.HandleAutoSuggestValChange}
                                Type="BankId"
                                options={this.state.Banklist}
                                val={this.state.BankId}
                                addPlaceholder=""
                                disabled={false}
                                loading={this.state.BankLoader}
                                searchBy="name"
                                labelField="name"
                                valueField="id"
                                contentRenderer={false}
                                placeholder="Select"
                            />
                        </div>

                        <div class="formInput_Container col-md-12 col-lg-12 col-12" style={{maxWidth: "420px"}}
                             hidden={this.state.RoleId == 4 ? false : true}>
                            <label for="">Account Number</label>
                            <input autocomplete="off" type="text" class="form-control" id="SignUp_AccountNumber"
                                   placeholder="Enter your Account Number"/>
                        </div>

                        <div class="loginform_footer formInput_Container col-md-12 col-lg-12 col-12"
                             style={{maxWidth: "420px"}}>
                            <button type="submit" class="btn LogInForm_btn">CREATE ACCOUNT</button>
                        </div>

                    </div>

                </form>

                <form id="Form_2ndStep" class="login_form" onSubmit={this.SubmitForm} novalidate
                      style={{display: "none"}}>

                    <div class="Form_PageTitle">Register</div>

                    <div class="loginform_Content" style={{marginTop: "0px", padding: "0px 135px"}}>
                        <p>Already have an account? <Link to="/Login" class="basicLink_Tag"> Sign In</Link></p>
                        <p style={{marginBottom: "10px", fontSize: "15px"}}>A verification code has been sent to your
                            phone number, please enter sent code to create account.</p>
                    </div>

                    <div class="loginform_form row d-flex justify-content-center">

                        <div class="formInput_Container col-md-12 col-lg-12 col-12" style={{maxWidth: "420px"}}>
                            <label for=""><span style={{color: "red"}}>* </span>Enter Code</label>
                            <input autocomplete="off" type="text" class="form-control" id="SignUp_VerficationCode"
                                   required/>
                        </div>

                        <div class="formInput_Container col-md-12 col-lg-12 col-12" style={{maxWidth: "420px"}}>
                            <div hidden={this.state.isExpired}>Resend ( <span class="countdown"></span> )</div>
                            <div style={{position: "absolute"}} hidden={!(this.state.isExpired)}><a
                                onClick={this.SendVerificationCode} style={{cursor: "pointer"}}
                                class="basicLink_Tag">Resend</a></div>
                        </div>

                        <div class="loginform_footer formInput_Container col-md-12 col-lg-12 col-12"
                             style={{maxWidth: "420px", marginTop: "15px"}}>
                            <button type="submit" class="btn LogInForm_btn">VERIFY</button>
                        </div>

                    </div>

                </form>

            </div>

        )
    }

    componentDidMount() {
        this.SelectRoles()
        this.SelectXpertSites()
        this.SelectHCF()
        this.SelectProvinces()
        this.SelectDistricts()
        this.SelectTehsil()
        this.SelectBank()
    }

    SelectRoles = () => {

        this.setState({RolesLoader: true})
        Common.Ajax("", "Get", false, Common.APILinks.SelectAll_Role, {},
            (Result) => {
                console.log(Result
                )
                if (Result.status) {
                    this.setState({
                        Roleslist: Result.data,
                        RolesLoader: false
                    })
                } else {
                    this.setState({
                        RolesLoader: false
                    })
                    this.props.ShowAlert({Type: 0, Msg: Result.message})
                    setTimeout(function () {
                        $("#Alertmsgbtn").click()
                    }, 50);
                }

            },
            (error) => {
                console.log(error)
                this.setState({
                    RolesLoader: false
                })
                this.props.ShowAlert({Type: 0, Msg: "Something went wrong, please try again"})
                setTimeout(function () {
                    $("#Alertmsgbtn").click()
                }, 50);
            }
        )

    }
    SelectXpertSites = () => {
        this.setState({XpertSiteLoader: true})
        Common.Ajax("", "Get", false, Common.APILinks.SelectAll_XpertSites, {isPaginate: false},
            (Result) => {
                if (Result.status == true) {
                    this.setState({
                        XpertSitelist: Result.data,
                        XpertSiteLoader: false
                    })
                } else {
                    this.setState({
                        XpertSiteLoader: false
                    })
                    this.props.ShowAlert({Type: 0, Msg: Result.message})
                    setTimeout(function () {
                        $("#Alertmsgbtn").click()
                    }, 50);
                }
            },
            (error) => {
                this.setState({
                    XpertSiteLoader: false
                })
                this.props.ShowAlert({Type: 0, Msg: "Something went wronge, please try again"})
                setTimeout(function () {
                    $("#Alertmsgbtn").click()
                }, 50);
            }
        )
    }
    SelectHCF = () => {
        this.setState({HCFLoader: true})
        Common.Ajax("", "Get", false, Common.APILinks.SelectAll_HCF, {isPaginate: false},
            (Result) => {
                if (Result.status == true) {
                    var BHUList = []
                    var RHCList = []
                    for (var i = 0; i < Result.data.length; i++) {
                        if (Result.data[i].typeId == 1) {
                            BHUList.push(Result.data[i])
                        } else {
                            RHCList.push(Result.data[i])
                        }
                    }
                    this.setState({
                        BHUList: BHUList,
                        RHCList: RHCList,
                        HCFLoader: false
                    })
                } else {
                    this.setState({
                        HCFLoader: false
                    })
                    this.props.ShowAlert({Type: 0, Msg: Result.message})
                    setTimeout(function () {
                        $("#Alertmsgbtn").click()
                    }, 50);
                }
            },
            (error) => {
                this.setState({
                    HCFLoader: false
                })
                this.props.ShowAlert({Type: 0, Msg: "Something went wronge, please try again"})
                setTimeout(function () {
                    $("#Alertmsgbtn").click()
                }, 50);
            }
        )
    }
    SelectProvinces = () => {
        this.setState({ProvinceLoader: true})
        Common.Ajax("", "Get", false, Common.APILinks.SelectAll_Province, {isPaginate: false},
            (Result) => {
                if (Result.status == true) {
                    this.setState({
                        Provincelist: Result.data,
                        ProvinceLoader: false
                    })
                } else {
                    this.setState({
                        ProvinceLoader: false
                    })
                    this.props.ShowAlert({Type: 0, Msg: Result.message})
                    setTimeout(function () {
                        $("#Alertmsgbtn").click()
                    }, 50);
                }
            },
            (error) => {
                this.setState({
                    ProvinceLoader: false
                })
                this.props.ShowAlert({Type: 0, Msg: "Something went wronge, please try again"})
                setTimeout(function () {
                    $("#Alertmsgbtn").click()
                }, 50);
            }
        )
    }
    SelectDistricts = () => {
        this.setState({DistrictLoader: true})
        Common.Ajax("", "Get", false, Common.APILinks.SelectAll_District, {isPaginate: false},
            (Result) => {
                if (Result.status == true) {
                    this.setState({
                        Districtlist: Result.data,
                        DistrictLoader: false
                    })
                } else {
                    this.setState({
                        DistrictLoader: false
                    })
                    this.props.ShowAlert({Type: 0, Msg: Result.message})
                    setTimeout(function () {
                        $("#Alertmsgbtn").click()
                    }, 50);
                }
            },
            (error) => {
                this.setState({
                    DistrictLoader: false
                })
                this.props.ShowAlert({Type: 0, Msg: "Something went wronge, please try again"})
                setTimeout(function () {
                    $("#Alertmsgbtn").click()
                }, 50);
            }
        )

    }
    SelectTehsil = () => {
        this.setState({TehsilLoader: true})
        Common.Ajax("", "Get", false, Common.APILinks.SelectAll_Tehsil, {isPaginate: false},
            (Result) => {
                if (Result.status == true) {
                    this.setState({
                        Tehsillist: Result.data,
                        TehsilLoader: false
                    })
                } else {
                    this.setState({
                        TehsilLoader: false
                    })
                    this.props.ShowAlert({Type: 0, Msg: Result.message})
                    setTimeout(function () {
                        $("#Alertmsgbtn").click()
                    }, 50);
                }
            },
            (error) => {
                this.setState({
                    TehsilLoader: false
                })
                this.props.ShowAlert({Type: 0, Msg: "Something went wronge, please try again"})
                setTimeout(function () {
                    $("#Alertmsgbtn").click()
                }, 50);
            }
        )

    }
    SelectBank = () => {
        this.setState({BankLoader: true})
        Common.Ajax("", "Get", false, Common.APILinks.SelectAll_Bank, null,
            (Result) => {
                if (Result.status == true) {
                    this.setState({
                        Banklist: Result.data,
                        BankLoader: false
                    })
                } else {
                    this.setState({
                        BankLoader: false
                    })
                    this.props.ShowAlert({Type: 0, Msg: Result.message})
                    setTimeout(function () {
                        $("#Alertmsgbtn").click()
                    }, 50);
                }
            },
            (error) => {
                this.setState({
                    BankLoader: false
                })
                this.props.ShowAlert({Type: 0, Msg: "Something went wronge, please try again"})
                setTimeout(function () {
                    $("#Alertmsgbtn").click()
                }, 50);
            })
    }
    ValidateSignUp = (e) => {
        e.preventDefault()
        if (this.state.ProvinceId == 0) {
            this.props.ShowAlert({Type: 0, Msg: "Please select province"})
            setTimeout(function () {
                $("#Alertmsgbtn").click()
            }, 50);
            return
        }
        if (this.state.AddressDistrictId == 0) {
            this.props.ShowAlert({Type: 0, Msg: "Please select user district"})
            setTimeout(function () {
                $("#Alertmsgbtn").click()
            }, 50);
            return
        }
        if (this.state.TehsilId == 0) {
            this.props.ShowAlert({Type: 0, Msg: "Please select tehsil"})
            setTimeout(function () {
                $("#Alertmsgbtn").click()
            }, 50);
            return
        }
        if (this.state.RoleId == 0) {
            this.props.ShowAlert({Type: 0, Msg: "Please select role"})
            setTimeout(function () {
                $("#Alertmsgbtn").click()
            }, 50);
            return
        }
        if (this.state.RoleId == 3 && this.state.XpertSiteId == 0) {
            this.props.ShowAlert({Type: 0, Msg: "Please select Xpert Site"})
            setTimeout(function () {
                $("#Alertmsgbtn").click()
            }, 50);
            return
        }
        // if(this.state.RoleId==5 && this.state.DistrictId==0)
        // {
        //     this.props.ShowAlert({Type:0,Msg: "Please select supervisor district"})
        //     setTimeout(function(){ $("#Alertmsgbtn").click()}, 50);
        //     return
        // }
        if (this.state.RoleId == 6 && this.state.BHUId == 0) {
            this.props.ShowAlert({Type: 0, Msg: "Please select BHU"})
            setTimeout(function () {
                $("#Alertmsgbtn").click()
            }, 50);
            return
        }
        if (this.state.RoleId == 7 && this.state.RHCId == 0) {
            this.props.ShowAlert({Type: 0, Msg: "Please select RHC"})
            setTimeout(function () {
                $("#Alertmsgbtn").click()
            }, 50);
            return
        }
        this.SendVerificationCode()
    }
    SendVerificationCode = () => {
        this.props.ShowLoader({Isloading: true})
        var Parameters = {
            contact: $("#SignUp_Contact").val(),
            email: $("#SignUp_Email").val(),
            password: $("#SignUp_Password").val(),
        }
        Common.Ajax("", "Post", false, Common.APILinks.ValidateSignUp, JSON.stringify(Parameters), (resp) => {
                this.props.ShowLoader({Isloading: false})
                if (resp.status == true) {
                    this.setState({
                        verificationCode: resp.code,
                        isExpired: false
                    }, () => {
                        $("#Form_1stStep").hide()
                        $("#Form_2ndStep").show()
                        this.startCounter()
                    })
                } else {
                    this.props.ShowAlert({Type: 0, Msg: resp.message})
                    setTimeout(() => {
                        $("#Alertmsgbtn").click()
                    }, 50);
                }
            },
            (error) => {
                this.props.ShowLoader({Isloading: false})
                this.props.ShowAlert({Type: 0, Msg: "Something went wronge, please try again."})
                setTimeout(() => {
                    $("#Alertmsgbtn").click()
                }, 50);
            })
    }
    startCounter = () => {
        var timer2 = "1:01";
        var interval = setInterval(() => {

            var timer = timer2.split(':');
            //by parsing integer, I avoid all extra string processing
            var minutes = parseInt(timer[0], 10);
            var seconds = parseInt(timer[1], 10);
            --seconds;
            minutes = (seconds < 0) ? --minutes : minutes;
            if (minutes < 0) clearInterval(interval);
            seconds = (seconds < 0) ? 59 : seconds;
            seconds = (seconds < 10) ? '0' + seconds : seconds;
            var counterlabel = minutes + ':' + seconds
            if (counterlabel == "0:00") {
                this.setState({
                    isExpired: true,
                    verificationCode: null,
                })
            }
            //minutes = (minutes < 10) ?  minutes : minutes;
            $('.countdown').html(counterlabel);
            timer2 = counterlabel;
        }, 1000);
    }
    SubmitForm = (e) => {
        e.preventDefault()

        if (this.state.isExpired) {
            this.props.ShowAlert({Type: 0, Msg: "Verification code is expired, please resend the code"})
            setTimeout(function () {
                $("#Alertmsgbtn").click()
            }, 50);
            return
        }
        if ($("#SignUp_VerficationCode").val() != this.state.verificationCode) {
            this.props.ShowAlert({Type: 0, Msg: "Invalid Code"})
            setTimeout(function () {
                $("#Alertmsgbtn").click()
            }, 50);
            return
        }

        this.props.ShowLoader({Isloading: true})
        var Parameters = {
            hcfId: this.state.RoleId == 6 ? this.state.BHUId : this.state.RoleId == 7 ? this.state.RHCId : 0,
            xpertSiteId: this.state.RoleId == 3 ? this.state.XpertSiteId : 0,
            districtId: this.state.RoleId == 5 ? this.state.DistrictId : 0,
            name: $("#SignUp_Name").val(),
            contact: $("#SignUp_Contact").val(),
            email: $("#SignUp_Email").val(),
            password: $("#SignUp_Password").val(),
            role: this.state.RoleId,
            isActive: true,
            addressProvinceId: this.state.ProvinceId,
            addressDistrictId: this.state.AddressDistrictId,
            addressTehsilId: this.state.TehsilId,
            vehicleNumber: this.state.RoleId == 4 ? $("#SignUp_VehicleNumber").val() : "",
            vehicleModel: this.state.RoleId == 4 ? $("#SignUp_VehicleModel").val() : "",
            accountNumber: this.state.RoleId == 4 ? $("#SignUp_AccountNumber").val() : "",
            bankId: this.state.RoleId == 4 ? this.state.BankId : 0
        }
        Common.Ajax("", "Post", false, Common.APILinks.SignUp, JSON.stringify(Parameters), (resp) => {
                this.props.ShowLoader({Isloading: false})
                if (resp.status == true) {
                    this.props.ShowAlert({Type: 1, Msg: "Account request sent for approval"})
                    setTimeout(() => {
                        $("#Alertmsgbtn").click()
                    }, 50);
                    this.ResetForm()
                } else {
                    this.props.ShowAlert({Type: 0, Msg: resp.message})
                    setTimeout(() => {
                        $("#Alertmsgbtn").click()
                    }, 50);
                }
            },
            (error) => {
                this.props.ShowLoader({Isloading: false})
                this.props.ShowAlert({Type: 0, Msg: "Something went wronge, please try again."})
                setTimeout(() => {
                    $("#Alertmsgbtn").click()
                }, 50);
            }
        )


    }
    ResetForm = () => {
        $("#Form_1stStep").show()
        $("#Form_2ndStep").hide()
        $("#SignUp_Name").val("")
        $("#SignUp_Contact").val("")
        $("#SignUp_Email").val("")
        $("#SignUp_Password").val("")
        $("#SignUp_VehicleNumber").val("")
        $("#SignUp_VehicleModel").val("")
        $("#SignUp_AccountNumber").val()
        this.setState({
            RoleId: 0,
            BHUId: 0,
            RHCId: 0,
            XpertSiteId: 0,
            DistrictId: 0,
            verificationCode: null,
            isExpired: true,
            ProvinceId: 0,
            AddressDistrictId: 0,
            TehsilId: 0,
            bankId: 0
        })
    }
    updatepasswordviewfun = (type) => {
        if (type == 1) {
            $("#hidepasswordlink").show()
            $("#viewpasswordlink").hide()
            $("#SignUp_Password").prop('type', 'text');
        } else {
            $("#hidepasswordlink").hide()
            $("#viewpasswordlink").show()
            $("#SignUp_Password").prop('type', 'password');
        }
    }
}


export default connect(mapStateToProps, mapDispatchToProps)(Signup);
